const userExperienceTypes = {
    DEFAULT: 'default',
    QUICK_START: 'quickStart',
};

export default userExperienceTypes;
